import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class MailValidators {
    static strictEmailValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const {value} = control;
        if (!value) { return null; }
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        return regex.test(value) ? null : { strictEmail: true };
    };
}
